module.exports = __webpack_public_path__ + "static/media/booking_icon.de9b965a.svg";